const PS_ADMIN_PASSWORD = 'presisjon2024';

// ============================================================
// BACKEND URL — sett inn Railway-URL etter deploy:
// Eksempel: const PS_BACKEND = 'https://mitt-prosjekt.railway.app';
const PS_BACKEND = '';
// ============================================================
// E-post mottas via Shopify sitt kontaktskjema (innstillinger → varsler)
// Endre e-post i Shopify Admin → Innstillinger → Varsler → Kontaktskjema

const PS_DEFAULT = {
  machineRate:12, minPrice:0, vat:25, eksprestillegg:200, currency:'NOK',
  rabatt1Fra:50, rabatt1Pst:5, rabatt2Fra:100, rabatt2Pst:10,
  frakt:{liten:76,middels:140,stor:251},
  materials:[
    {id:'pla',name:'PLA',desc:'God overflate, lav pris',popular:true,pricePerG:0.18,density:1.24,postCost:10,quality:1.0,color:'#2a7de1',uses:['Prototyper','Dekorasjon'],info:'PLA er det mest brukte materialet. Passer til modeller, prototyper og innendørs gjenstander. Tåler ikke høy varme over ~60°C.',farger:[{hex:'#ffffff',navn:'Hvit'},{hex:'#1a1a1a',navn:'Svart'},{hex:'#e63946',navn:'Rød'},{hex:'#2a7de1',navn:'Blå'},{hex:'#1D9E75',navn:'Grønn'},{hex:'#f4a261',navn:'Oransje'},{hex:'#ffd166',navn:'Gul'},{hex:'#c77dff',navn:'Lilla'}]},
    {id:'abs',name:'ABS',desc:'Hard og slagbestandig',popular:false,pricePerG:0.22,density:1.05,postCost:10,quality:1.1,color:'#E87A1A',uses:['Tekniske deler','Kabinetter'],info:'ABS er hardt og tåler slag. Kan etterbehandles med aceton for glatt overflate.',farger:[{hex:'#ffffff',navn:'Hvit'},{hex:'#1a1a1a',navn:'Svart'},{hex:'#e63946',navn:'Rød'},{hex:'#2a7de1',navn:'Blå'}]},
    {id:'asa',name:'ASA',desc:'UV-bestandig for utendørs bruk',popular:false,pricePerG:0.28,density:1.07,postCost:10,quality:1.1,color:'#2e8b57',uses:['Utendørs deler','Bildeler','UV-eksponert'],info:'ASA er som ABS men tåler sol og vær uten å bli sprø. Perfekt for utendørs bruk. Krever lukket printer.',farger:[{hex:'#ffffff',navn:'Hvit'},{hex:'#1a1a1a',navn:'Svart'},{hex:'#808080',navn:'Grå'},{hex:'#e63946',navn:'Rød'}]},
    {id:'petg',name:'PETG',desc:'Sterk og temperaturbestandig',popular:false,pricePerG:0.24,density:1.27,postCost:10,quality:1.05,color:'#1D9E75',uses:['Funksjonelle deler','Utendørs'],info:'PETG kombinerer styrke og fleksibilitet. Godt valg for funksjonelle deler og utendørs bruk.',farger:[{hex:'#ffffff',navn:'Hvit'},{hex:'#1a1a1a',navn:'Svart'},{hex:'#2a7de1',navn:'Blå'},{hex:'#1D9E75',navn:'Grønn'},{hex:'#e63946',navn:'Rød'}]},
    {id:'pctg_cf',name:'PCTG-CF',desc:'Karbonfiber — stiv og lett',popular:false,pricePerG:0.85,density:1.2,postCost:20,quality:1.3,color:'#4a90c4',uses:['Strukturelle deler','Lav vekt'],info:'PCTG med karbonfiber gir høy stivhet og lav vekt.',farger:[{hex:'#1a1a1a',navn:'Karbonsvart'}]},
    {id:'ppa_cf',name:'PPA-CF',desc:'Karbonfiber — ekstremt sterk',popular:false,pricePerG:1.20,density:1.15,postCost:25,quality:1.5,color:'#6366f1',uses:['Industrideler','Ekstrem styrke'],info:'Et av de sterkeste FDM-materialene. Tåler høye temperaturer og kjemikalier.',farger:[{hex:'#1a1a1a',navn:'Karbonsvart'}]},
    {id:'nylon_pa12',name:'Nylon PA12',desc:'Seig og slitesterk',popular:false,pricePerG:0.95,density:1.01,postCost:20,quality:1.4,color:'#8A6FBF',uses:['Slitedeler','Tannhjul'],info:'Svært seigt og slitesterkt med god kjemisk bestandighet.',farger:[{hex:'#ffffff',navn:'Hvit'},{hex:'#1a1a1a',navn:'Svart'},{hex:'#8A6FBF',navn:'Grå'}]},
    {id:'paht_cf',name:'PAHT-CF',desc:'Høytemperatur karbonfiber',popular:false,pricePerG:1.40,density:1.18,postCost:30,quality:1.6,color:'#e63946',uses:['Høy temperatur','Motorsport'],info:'Tåler over 150°C kontinuerlig. For krevende industrimiljøer og motorsport.',farger:[{hex:'#1a1a1a',navn:'Karbonsvart'},{hex:'#4a4a4a',navn:'Mørkgrå'}]},
  ],
  infills:[
    {pct:15,label:'15% — Lett',desc:'For modeller uten belastning.'},
    {pct:30,label:'30% — Standard',desc:'Balanse mellom styrke og forbruk.'},
    {pct:50,label:'50% — Solid',desc:'For funksjonelle deler.'},
    {pct:100,label:'100% — Massiv',desc:'Maksimal styrke.'},
  ]
};

let psCfg = JSON.parse(JSON.stringify(PS_DEFAULT));
let psCurMat = psCfg.materials[0].id;
let psCurInfill = 15;
let psFileVol = null;
let psAdminUnlocked = false;
let psCurProd = 0, psCurProdType = 'standard';
let psCurFrakt = 76, psCurFraktType = 'liten';
let psCurKvalFaktor = 1.0, psCurKvalNavn = 'Standard';
let psCurFargeIdx = null;
let psSlicerGram = null;  // Eksakt gram fra slicer
let psSlicerTid  = null;  // Eksakt tid fra slicer

(function(){try{const s=localStorage.getItem('ps_cfg_v3');if(s)psCfg=Object.assign(JSON.parse(JSON.stringify(PS_DEFAULT)),JSON.parse(s));}catch(e){}})();

function psFmt(n){return new Intl.NumberFormat('nb-NO',{style:'currency',currency:'NOK',maximumFractionDigits:0}).format(n);}

function psRenderMat(){
  const g=document.getElementById('ps-matGrid');g.innerHTML='';
  psCfg.materials.forEach(m=>{
    const b=document.createElement('button'),a=m.id===psCurMat;
    b.className='ps-mat-btn'+(a?' active':'');
    if(a)b.style.borderColor=m.color;
    const t=(m.uses||[]).slice(0,2).map(u=>`<span class="ps-mat-tag">${u}</span>`).join('');
    b.innerHTML=`<div class="ps-mn"><span class="ps-mat-dot" style="background:${m.color}"></span>${m.name}${m.popular?'<span class="ps-pop-badge">Populær</span>':''}</div><div class="ps-md">${m.desc}</div>${t?`<div class="ps-tags">${t}</div>`:''}`;
    b.onclick=()=>{psCurMat=m.id;psCurFargeIdx=null;psRenderMat();psShowMatInfo();psRenderColorSection();psUpdatePrice();};
    g.appendChild(b);
  });
  psShowMatInfo();
  psRenderColorSection();
}

function psShowMatInfo(){
  const m=psCfg.materials.find(x=>x.id===psCurMat),b=document.getElementById('ps-matInfo');
  if(!m||!m.info){b.classList.remove('show');return;}
  b.style.borderLeftColor=m.color;
  const u=(m.uses||[]).map(u=>`<span class="ps-use-case">${u}</span>`).join('');
  b.innerHTML=`<strong>${m.name} — når passer det?</strong>${m.info}${u?`<div class="ps-use-cases">${u}</div>`:''}`;
  b.classList.add('show');
}

function psRenderColorSection(){
  const section=document.getElementById('ps-colorSection');
  const mat=psCfg.materials.find(x=>x.id===psCurMat);
  if(!mat){section.innerHTML='';return;}
  const farger=mat.farger||[];
  if(farger.length===0){
    section.innerHTML=`<div class="ps-color-section"><div class="ps-color-section-title"><i class="ti ti-palette"></i> Farge</div><div class="ps-color-none">Ingen farger tilgjengelig for dette materialet</div></div>`;
    return;
  }
  let swatches=farger.map((f,i)=>`
    <div class="ps-color-item${psCurFargeIdx===i?' active':''}" onclick="psSelFarge(${i})">
      <div class="ps-color-swatch" style="background:${f.hex}"></div>
      <div class="ps-color-label">${f.navn}</div>
    </div>`).join('');
  // pluss-knapp for kunden
  swatches+=`<div style="display:flex;flex-direction:column;align-items:center;gap:4px;">
    <button class="ps-color-add-btn" onclick="psKundeLeggTilFarge()" title="Legg til farge"><i class="ti ti-plus"></i></button>
    <div style="font-size:10px;color:var(--text2);">Annen</div>
  </div>`;
  const valgt=psCurFargeIdx!==null?`<div class="ps-selected-color"><span class="ps-selected-dot" style="background:${farger[psCurFargeIdx].hex}"></span>Valgt: <strong>${farger[psCurFargeIdx].navn}</strong></div>`:'';
  section.innerHTML=`<div class="ps-color-section"><div class="ps-color-section-title"><i class="ti ti-palette"></i> Farge</div><div class="ps-color-row">${swatches}</div>${valgt}</div>`;
}

function psSelFarge(i){psCurFargeIdx=i;psRenderColorSection();}

function psKundeLeggTilFarge(){
  const input=document.createElement('input');input.type='color';input.style.display='none';
  document.body.appendChild(input);input.click();
  input.onchange=()=>{
    const hex=input.value;
    const navn=prompt('Gi fargen et navn (f.eks. Mørk grå):','');
    if(navn&&navn.trim()){
      const mat=psCfg.materials.find(x=>x.id===psCurMat);
      if(mat){mat.farger=mat.farger||[];mat.farger.push({hex,navn:navn.trim()});psCurFargeIdx=mat.farger.length-1;}
      psRenderColorSection();
    }
    document.body.removeChild(input);
  };
}

function psSelKval(btn,faktor,navn){
  document.querySelectorAll('.ps-qual-btn').forEach(b=>b.classList.remove('active'));
  btn.classList.add('active');psCurKvalFaktor=faktor;psCurKvalNavn=navn;psUpdatePrice();
}

function psRenderInfill(){
  const g=document.getElementById('ps-infillGrid');g.innerHTML='';
  psCfg.infills.forEach(inf=>{
    const b=document.createElement('button'),a=inf.pct===psCurInfill;
    b.className='ps-if-btn'+(a?' active':'');
    b.innerHTML=`<div class="ps-if-name">${inf.label}</div><div class="ps-if-desc">${inf.desc}</div>`;
    b.onclick=()=>{psCurInfill=inf.pct;psRenderInfill();psUpdatePrice();};
    g.appendChild(b);
  });
}

function psSelProd(btn,tillegg,type){
  document.querySelectorAll('.ps-prod-btn').forEach(b=>b.classList.remove('active'));
  btn.classList.add('active');psCurProd=tillegg;psCurProdType=type;
  document.getElementById('ps-ekspressRow').style.display=tillegg>0?'flex':'none';
  psUpdatePrice();
}

function psSelFrakt(btn,pris,type){
  document.querySelectorAll('.ps-frakt-btn').forEach(b=>b.classList.remove('active'));
  btn.classList.add('active');psCurFrakt=pris;psCurFraktType=type;
  document.getElementById('ps-fraktRow').style.display=type==='henting'?'none':'flex';
  psUpdatePrice();
}

function psUpdatePrice(){
  if(psFileVol===null)return;
  const qty=parseInt(document.getElementById('ps-qtyS').value);
  document.getElementById('ps-qtyV').textContent=qty+' stk';
  const m=psCfg.materials.find(x=>x.id===psCurMat);if(!m)return;
  // Bruk eksakt slicer-verdi hvis tilgjengelig, ellers estimat
  const grams = psSlicerGram !== null ? Math.round(psSlicerGram) : Math.round(psFileVol*m.density*(0.421+(psCurInfill/100)*0.403));
  // Bruk eksakt slicer-verdi hvis tilgjengelig, ellers estimat
  const infillFactor=psCurInfill/15;
  const hours = psSlicerTid !== null ? Math.round(psSlicerTid * qty * 10)/10 : Math.round((0.006*Math.pow(psFileVol,1.142)+0.167)*infillFactor*psCurKvalFaktor*10)/10;
  const mc=grams*m.pricePerG,tc=hours*psCfg.machineRate,pc=m.postCost;
  let printUnit=mc+tc+pc;
  let printTotal=printUnit*qty;
  const mp=parseFloat(psCfg.minPrice)||0;
  if(printTotal<mp&&mp>0)printTotal=mp;
  const r1Fra=parseInt(psCfg.rabatt1Fra)||50,r1Pst=parseFloat(psCfg.rabatt1Pst)||5;
  const r2Fra=parseInt(psCfg.rabatt2Fra)||100,r2Pst=parseFloat(psCfg.rabatt2Pst)||10;
  let rabattKr=0;
  const badge=document.getElementById('ps-rabattBadge'),bulk=document.getElementById('ps-bulkInfo'),rRow=document.getElementById('ps-rabattRow');
  if(qty>r2Fra){
    bulk.textContent='Over '+r2Fra+' stk — kontakt oss for tilbud på store volum!';
    bulk.classList.add('show');badge.classList.remove('show');rRow.style.display='none';
  } else {
    bulk.classList.remove('show');
    let rPst=0;
    if(qty>=r2Fra)rPst=r2Pst;
    else if(qty>=r1Fra)rPst=r1Pst;
    if(rPst>0){
      rabattKr=Math.round(printTotal*(rPst/100));printTotal-=rabattKr;
      badge.textContent=rPst+'% kvantumsrabatt — du sparer '+psFmt(rabattKr)+'!';
      badge.classList.add('show');rRow.style.display='flex';
      document.getElementById('ps-rabattVal').textContent='− '+psFmt(rabattKr);
    } else {badge.classList.remove('show');rRow.style.display='none';}
  }
  const ekspPris=parseFloat(psCfg.eksprestillegg)||200;
  const fraktPris=psCurFraktType==='henting'?0:psCurFrakt;
  const total=printTotal+(psCurProdType==='ekspress'?ekspPris:0)+fraktPris;
  document.getElementById('ps-gV').textContent=grams*qty;
  document.getElementById('ps-tV').textContent=(hours*qty).toFixed(1);
  document.getElementById('ps-mcV').textContent=psFmt(mc*qty);
  document.getElementById('ps-tcV').textContent=psFmt(tc*qty);
  document.getElementById('ps-pcV').textContent=psFmt(pc*qty);
  document.getElementById('ps-ekspressVal').textContent=psFmt(ekspPris);
  document.getElementById('ps-fraktSum').textContent=psFmt(fraktPris);
  document.getElementById('ps-totV').textContent=psFmt(total);
  document.getElementById('ps-minNote').style.display=(printTotal===mp&&mp>0)?'block':'none';
  const vn=psCfg.vat>0?`eks. ${psCfg.vat}% mva`:'inkl. mva';
  document.getElementById('ps-totalNote').textContent=qty>1?`${qty} stk · ${vn}`:vn;
}

function psEstimateSTL(buf){
  const v=new DataView(buf);
  try{const h=new Uint8Array(buf,0,5);
    if(!(h[0]===115&&h[1]===111&&h[2]===108&&h[3]===105&&h[4]===100)){
      const n=v.getUint32(80,true);let vol=0;
      for(let i=0;i<n;i++){const o=84+i*50;
        const v1x=v.getFloat32(o+12,true),v1y=v.getFloat32(o+16,true),v1z=v.getFloat32(o+20,true);
        const v2x=v.getFloat32(o+24,true),v2y=v.getFloat32(o+28,true),v2z=v.getFloat32(o+32,true);
        const v3x=v.getFloat32(o+36,true),v3y=v.getFloat32(o+40,true),v3z=v.getFloat32(o+44,true);
        vol+=(v1x*(v2y*v3z-v2z*v3y)-v1y*(v2x*v3z-v2z*v3x)+v1z*(v2x*v3y-v2y*v3x))/6;
      }return Math.abs(vol)/1000;
    }
  }catch(e){}return null;
}

function psOnFile(input){
  const f=input.files[0];if(!f)return;
  if(!f.name.toLowerCase().endsWith('.stl')){
    alert('Kun STL-filer støttes. Eksporter STL fra din slicer.');
    input.value='';return;
  }
  document.getElementById('ps-fileName').textContent=f.name;
  document.getElementById('ps-fileMeta').textContent='Analyserer fil...';
  document.getElementById('ps-fileBadge').style.display='block';
  document.getElementById('ps-noFile').style.display='none';
  const reader=new FileReader();
  reader.onload=e=>{
    const vol=psEstimateSTL(e.target.result);
    psFileVol=vol!==null&&vol>=0.1?Math.round(vol*10)/10:1;
    psVisFilInfo(f.size);
  };
  reader.readAsArrayBuffer(f);
}

function psSliceMedBackend(fil){
  const formData = new FormData();
  formData.append('fil', fil);
  formData.append('material', psCurMat);
  formData.append('infill', psCurInfill);
  formData.append('lagtykkelse', '0.2');
  formData.append('kvalitet', psCurKvalNavn.toLowerCase());

  document.getElementById('ps-fileMeta').textContent = 'Slicer filen... vent litt';

  fetch(PS_BACKEND + '/slice', {
    method: 'POST',
    body: formData
  })
  .then(r => r.json())
  .then(data => {
    psFileVol = data.volum_cm3 || psFileVol;
    // Overstyr gram og tid direkte med eksakte verdier fra slicer
    psSlicerGram  = data.gram;
    psSlicerTid   = data.tid_timer;
    document.getElementById('ps-fileMeta').textContent =
      `${(fil.size/1024).toFixed(0)} KB · ${data.gram}g · ${data.tid_min}min (fra slicer)`;
    document.getElementById('ps-calcBody').style.display='block';
    psUpdatePrice();
  })
  .catch(err => {
    console.warn('Backend utilgjengelig, bruker estimat:', err);
    document.getElementById('ps-fileMeta').textContent = 'Estimerer...';
    // Fallback til lokal estimering
    const reader = new FileReader();
    reader.onload = e => {
      const ext = fil.name.split('.').pop().toLowerCase();
      if(ext==='stl'){
        const vol=psEstimateSTL(e.target.result);
        psFileVol=vol!==null&&vol>=0.1?Math.round(vol*10)/10:1;
        psVisFilInfo(fil.size);
      } else {
        psEstimate3MF(e.target.result, fil.size);
      }
    };
    reader.readAsArrayBuffer(fil);
  });
}

function psVisFilInfo(size){
  document.getElementById('ps-fileMeta').textContent=`${(size/1024).toFixed(0)} KB · volum ${psFileVol} cm³ (nøyaktig)`;
  document.getElementById('ps-fileBadge').style.display='block';
  document.getElementById('ps-noFile').style.display='none';
  document.getElementById('ps-calcBody').style.display='block';
  psUpdatePrice();
}

function psEstimate3MF(buffer,fileSize){
  // 3MF er en ZIP - bruk JSZip til å lese den
  const script=document.getElementById('jszip-script');
  if(!script){
    const s=document.createElement('script');
    s.id='jszip-script';
    s.src='https://cdnjs.cloudflare.com/ajax/libs/jszip/3.10.1/jszip.min.js';
    s.onload=()=>psParse3MF(buffer,fileSize);
    document.head.appendChild(s);
  } else {
    psParse3MF(buffer,fileSize);
  }
}

function psParse3MF(buffer,fileSize){
  JSZip.loadAsync(buffer).then(zip=>{
    // Finn 3D model-filen
    const modelFile=Object.keys(zip.files).find(n=>n.toLowerCase().endsWith('.model'));
    if(!modelFile){psFileVol=2;psVisFilInfo(fileSize);return;}
    zip.files[modelFile].async('string').then(xml=>{
      const parser=new DOMParser();
      const doc=parser.parseFromString(xml,'text/xml');
      const vertices=[...doc.querySelectorAll('vertex')].map(v=>({
        x:parseFloat(v.getAttribute('x')),
        y:parseFloat(v.getAttribute('y')),
        z:parseFloat(v.getAttribute('z'))
      }));
      const triangles=[...doc.querySelectorAll('triangle')];
      if(vertices.length===0||triangles.length===0){psFileVol=2;psVisFilInfo(fileSize);return;}
      let vol=0;
      triangles.forEach(t=>{
        const v1=vertices[parseInt(t.getAttribute('v1'))];
        const v2=vertices[parseInt(t.getAttribute('v2'))];
        const v3=vertices[parseInt(t.getAttribute('v3'))];
        if(!v1||!v2||!v3)return;
        vol+=(v1.x*(v2.y*v3.z-v2.z*v3.y)-v1.y*(v2.x*v3.z-v2.z*v3.x)+v1.z*(v2.x*v3.y-v2.y*v3.x))/6;
      });
      const vol_cm3=Math.abs(vol)/1000;
      psFileVol=vol_cm3>=0.1?Math.round(vol_cm3*10)/10:1;
      psVisFilInfo(fileSize);
    });
  }).catch(()=>{psFileVol=2;psVisFilInfo(fileSize);});
}

const psDz=document.getElementById('ps-dz');
if(psDz){
  psDz.addEventListener('dragover',e=>{e.preventDefault();psDz.classList.add('drag');});
  psDz.addEventListener('dragleave',()=>psDz.classList.remove('drag'));
  psDz.addEventListener('drop',e=>{
    e.preventDefault();psDz.classList.remove('drag');
    const fi=document.getElementById('ps-fi');
    fi.files=e.dataTransfer.files;
    psOnFile(fi);
  });
}

function psValider(){
  const felt=['ps-cf-navn','ps-cf-epost','ps-cf-tlf','ps-cf-gate','ps-cf-postnr','ps-cf-poststed'];
  let ok=true;
  felt.forEach(id=>{const el=document.getElementById(id);if(!el.value.trim()){el.classList.add('ps-error');ok=false;}else el.classList.remove('ps-error');});
  const ep=document.getElementById('ps-cf-epost');
  if(ep.value&&!/^[^@]+@[^@]+\.[^@]+$/.test(ep.value)){ep.classList.add('ps-error');ok=false;}
  document.getElementById('ps-form-error').classList.toggle('show',!ok);
  return ok;
}

function psSend(){
  if(!psValider())return;

  const qty   = document.getElementById('ps-qtyS').value;
  const mat   = psCfg.materials.find(x=>x.id===psCurMat);
  const tot   = document.getElementById('ps-totV').textContent;
  const mat_farger = mat&&mat.farger?mat.farger:[];
  const farge = psCurFargeIdx!==null&&mat_farger[psCurFargeIdx]?mat_farger[psCurFargeIdx].navn:'Ikke valgt';
  const prod  = psCurProdType==='ekspress'?'Ekspress 48t (+'+psCfg.eksprestillegg+' kr)':'Standard (5–7 virkedager)';
  const frakt = psCurFraktType==='henting'?'Henter selv':psCurFraktType==='liten'?'Liten pakke ('+psCfg.frakt.liten+' kr)':psCurFraktType==='middels'?'Middels pakke ('+psCfg.frakt.middels+' kr)':'Stor pakke ('+psCfg.frakt.stor+' kr)';
  const navn      = document.getElementById('ps-cf-navn').value;
  const epost     = document.getElementById('ps-cf-epost').value;
  const tlf       = document.getElementById('ps-cf-tlf').value;
  const gate      = document.getElementById('ps-cf-gate').value;
  const postnr    = document.getElementById('ps-cf-postnr').value;
  const poststed  = document.getElementById('ps-cf-poststed').value;

  // Bygg melding
  const melding =
    '=== KONTAKTOPPLYSNINGER ===\n' +
    'Navn:         ' + navn + '\n' +
    'E-post:       ' + epost + '\n' +
    'Telefon:      ' + tlf + '\n' +
    'Adresse:      ' + gate + ', ' + postnr + ' ' + poststed + '\n\n' +
    '=== BESTILLINGSDETALJER ===\n' +
    'Material:     ' + mat?.name + '\n' +
    'Farge:        ' + farge + '\n' +
    'Kvalitet:     ' + psCurKvalNavn + '\n' +
    'Fyll:         ' + psCurInfill + '%\n' +
    'Antall:       ' + qty + ' stk\n' +
    'Produksjon:   ' + prod + '\n' +
    'Frakt:        ' + frakt + '\n' +
    'Prisestimat:  ' + tot + '\n\n' +
    'NB: Fil lastet opp via kalkulator — slice og bekreft endelig pris.';

  const btn = document.getElementById('ps-sendBtn');
  if(btn){ btn.textContent = 'Sender...'; btn.disabled = true; }

  var formData = new FormData();
  formData.append('name',    navn);
  formData.append('email',   epost);
  formData.append('phone',   tlf);
  formData.append('adresse', gate + ', ' + postnr + ' ' + poststed);
  formData.append('message', melding);

  // Legg ved STL-filen hvis den er lastet opp
  var filInput = document.getElementById('ps-fi');
  if(filInput && filInput.files && filInput.files[0]){
    formData.append('attachment', filInput.files[0], filInput.files[0].name);
  }

  fetch('https://formspree.io/f/xwvjbgwd', {
    method: 'POST',
    headers: { 'Accept': 'application/json' },
    body: formData
  })
  .then(function(r){
    if(r.ok){
      if(btn){ btn.textContent = 'Sendt! Vi kontakter deg innen 24 timer.'; btn.style.background='#198754'; }
    } else {
      r.json().then(function(data){ console.error('Formspree feil:', data); });
      if(btn){ btn.textContent = 'Noe gikk galt, prøv igjen'; btn.disabled = false; btn.style.background=''; }
    }
  })
  .catch(function(err){
    console.error('Nettverksfeil:', err);
    if(btn){ btn.textContent = 'Noe gikk galt, prøv igjen'; btn.disabled = false; btn.style.background=''; }
  });
}

function psShowTab(id,el){
  document.querySelectorAll('.ps-tab').forEach(t=>t.classList.remove('active'));
  document.querySelectorAll('.ps-panel').forEach(p=>{
    p.classList.remove('active');
    p.style.display='none';
  });
  el.classList.add('active');
  var panel = document.getElementById('ps-panel-'+id);
  panel.classList.add('active');
  panel.style.display='block';
  if(id==='admin'){psLoadAdminFields();psRenderMatAdmin();}
  psFixTabColor();
}
function psFixTabColor(){document.querySelectorAll('.ps-tab').forEach(t=>t.style.removeProperty('color'));}
function psOpenPwModal(){
  if(psAdminUnlocked){psShowTab('admin',document.getElementById('ps-lockBtn'));return;}
  document.getElementById('ps-pwModal').classList.add('open');
  setTimeout(()=>document.getElementById('ps-pwInput').focus(),50);
}
function psClosePwModal(){document.getElementById('ps-pwModal').classList.remove('open');document.getElementById('ps-pwInput').value='';document.getElementById('ps-pwError').classList.remove('show');}
function psCheckPw(){
  const v=document.getElementById('ps-pwInput').value;
  if(v===PS_ADMIN_PASSWORD){
    psAdminUnlocked=true;psClosePwModal();
    const lb=document.getElementById('ps-lockBtn');
    lb.innerHTML='<i class="ti ti-settings"></i>';
    lb.onclick=function(){psShowTab('admin',this);};
    psShowTab('admin',lb);
  } else {
    document.getElementById('ps-pwError').classList.add('show');
    document.getElementById('ps-pwInput').value='';document.getElementById('ps-pwInput').focus();
  }
}

function psRenderMatAdmin(){
  const l=document.getElementById('ps-matAdminList');l.innerHTML='';
  psCfg.materials.forEach((m,i)=>{
    const c=document.createElement('div');c.className='ps-mat-admin-card';
    const fargeChips=(m.farger||[]).map((f,fi)=>`
      <div class="ps-mat-color-chip">
        <div class="ps-mat-color-dot" style="background:${f.hex}"></div>
        ${f.navn}
        <button class="ps-mat-color-del" onclick="psSlettFarge(${i},${fi})" title="Slett">&times;</button>
      </div>`).join('');
    c.innerHTML=`
      <div class="ps-mat-admin-title"><span class="ps-dot" style="background:${m.color}"></span>${m.name}<button class="ps-del-btn" onclick="psDeleteMat(${i})"><i class="ti ti-trash"></i></button></div>
      <div class="ps-field-grid">
        <div class="ps-field"><label>Pris per gram (kr)</label><input type="number" step="0.01" min="0" value="${m.pricePerG}" oninput="psCfg.materials[${i}].pricePerG=parseFloat(this.value)||0;psUpdatePrice()"></div>
        <div class="ps-field"><label>Etterbehandling (kr)</label><input type="number" min="0" value="${m.postCost}" oninput="psCfg.materials[${i}].postCost=parseFloat(this.value)||0;psUpdatePrice()"></div>
        <div class="ps-field"><label>Knapfarge</label><input type="color" value="${m.color}" oninput="psCfg.materials[${i}].color=this.value;psRenderMat()"></div>
        <div class="ps-field"><label>Passer til</label><input type="text" value="${(m.uses||[]).join(', ')}" oninput="psCfg.materials[${i}].uses=this.value.split(',').map(s=>s.trim()).filter(Boolean);psRenderMat()"></div>
      </div>
      <div class="ps-field" style="margin-top:8px"><label>Forklarende tekst</label><textarea oninput="psCfg.materials[${i}].info=this.value;psShowMatInfo()">${m.info||''}</textarea></div>
      <div class="ps-mat-colors-section">
        <div class="ps-mat-colors-title"><i class="ti ti-palette"></i> Tilgjengelige farger</div>
        <div class="ps-mat-colors-row" id="ps-mat-colors-${i}">${fargeChips||'<span style="font-size:12px;color:var(--text2);font-style:italic;">Ingen farger lagt til</span>'}</div>
        <div class="ps-mat-add-color">
          <input type="color" id="ps-nc-hex-${i}" value="#ffffff">
          <input type="text" id="ps-nc-navn-${i}" placeholder="Fargenavn (f.eks. Hvit)">
          <button class="ps-mat-add-color-btn" onclick="psLeggTilFarge(${i})"><i class="ti ti-plus"></i> Legg til</button>
        </div>
      </div>`;
    l.appendChild(c);
  });
}

function psLeggTilFarge(i){
  const hex=document.getElementById('ps-nc-hex-'+i).value;
  const navn=document.getElementById('ps-nc-navn-'+i).value.trim();
  if(!navn){document.getElementById('ps-nc-navn-'+i).focus();return;}
  psCfg.materials[i].farger=psCfg.materials[i].farger||[];
  psCfg.materials[i].farger.push({hex,navn});
  document.getElementById('ps-nc-navn-'+i).value='';
  psRenderMatAdmin();
  if(psCurMat===psCfg.materials[i].id)psRenderColorSection();
}

function psSlettFarge(matIdx,fargeIdx){
  psCfg.materials[matIdx].farger.splice(fargeIdx,1);
  if(psCurMat===psCfg.materials[matIdx].id&&psCurFargeIdx===fargeIdx)psCurFargeIdx=null;
  psRenderMatAdmin();
  if(psCurMat===psCfg.materials[matIdx].id)psRenderColorSection();
}

function psDeleteMat(i){
  if(psCfg.materials.length<=1)return;
  const id=psCfg.materials[i].id;psCfg.materials.splice(i,1);
  if(psCurMat===id)psCurMat=psCfg.materials[0].id;
  psRenderMatAdmin();psRenderMat();psUpdatePrice();
}
function psToggleNewForm(){document.getElementById('ps-newMatForm').classList.toggle('open');}
function psAddMaterial(){
  const name=document.getElementById('ps-nm-name').value.trim();if(!name){document.getElementById('ps-nm-name').focus();return;}
  psCfg.materials.push({id:name.toLowerCase().replace(/\s+/g,'_')+'_'+Date.now(),name,desc:document.getElementById('ps-nm-desc').value||'',pricePerG:parseFloat(document.getElementById('ps-nm-price').value)||0.25,density:1.2,postCost:parseFloat(document.getElementById('ps-nm-post').value)||10,quality:1.0,color:document.getElementById('ps-nm-color').value,popular:false,uses:document.getElementById('ps-nm-uses').value.split(',').map(s=>s.trim()).filter(Boolean),info:document.getElementById('ps-nm-info').value||'',farger:[]});
  ['ps-nm-name','ps-nm-desc','ps-nm-uses','ps-nm-info'].forEach(id=>document.getElementById(id).value='');
  document.getElementById('ps-newMatForm').classList.remove('open');
  psRenderMatAdmin();psRenderMat();psUpdatePrice();
}
function psLoadAdminFields(){
  document.getElementById('ps-machinerate').value=psCfg.machineRate;
  document.getElementById('ps-minprice').value=psCfg.minPrice;
  document.getElementById('ps-vat').value=psCfg.vat;
  document.getElementById('ps-eksprestillegg').value=psCfg.eksprestillegg||200;
  document.getElementById('ps-rabatt1-fra').value=psCfg.rabatt1Fra||50;
  document.getElementById('ps-rabatt1-pst').value=psCfg.rabatt1Pst||5;
  document.getElementById('ps-rabatt2-fra').value=psCfg.rabatt2Fra||100;
  document.getElementById('ps-rabatt2-pst').value=psCfg.rabatt2Pst||10;
  document.getElementById('ps-frakt-liten').value=(psCfg.frakt&&psCfg.frakt.liten)||76;
  document.getElementById('ps-frakt-middels').value=(psCfg.frakt&&psCfg.frakt.middels)||140;
  document.getElementById('ps-frakt-stor').value=(psCfg.frakt&&psCfg.frakt.stor)||251;
}
function psSaveConfig(){
  psCfg.machineRate=parseFloat(document.getElementById('ps-machinerate').value)||12;
  psCfg.minPrice=parseFloat(document.getElementById('ps-minprice').value)||0;
  psCfg.vat=parseFloat(document.getElementById('ps-vat').value)||25;
  psCfg.eksprestillegg=parseFloat(document.getElementById('ps-eksprestillegg').value)||200;
  psCfg.rabatt1Fra=parseInt(document.getElementById('ps-rabatt1-fra').value)||50;
  psCfg.rabatt1Pst=parseFloat(document.getElementById('ps-rabatt1-pst').value)||5;
  psCfg.rabatt2Fra=parseInt(document.getElementById('ps-rabatt2-fra').value)||100;
  psCfg.rabatt2Pst=parseFloat(document.getElementById('ps-rabatt2-pst').value)||10;
  psCfg.frakt={liten:parseFloat(document.getElementById('ps-frakt-liten').value)||76,middels:parseFloat(document.getElementById('ps-frakt-middels').value)||140,stor:parseFloat(document.getElementById('ps-frakt-stor').value)||251};
  try{localStorage.setItem('ps_cfg_v3',JSON.stringify(psCfg));}catch(e){}
  document.getElementById('ps-fp-liten').innerHTML=psCfg.frakt.liten+' <span>kr</span>';
  document.getElementById('ps-fp-middels').innerHTML=psCfg.frakt.middels+' <span>kr</span>';
  document.getElementById('ps-fp-stor').innerHTML=psCfg.frakt.stor+' <span>kr</span>';
  document.getElementById('ps-ekspPris').innerHTML='+ '+psCfg.eksprestillegg+' <span>kr tillegg</span>';
  psRenderMat();psRenderInfill();psUpdatePrice();
  const msg=document.getElementById('ps-savedMsg');msg.classList.add('show');
  setTimeout(()=>msg.classList.remove('show'),2500);
}

psRenderMat();psRenderInfill();psFixTabColor();

// Bind all events via addEventListener to work with Shopify
document.addEventListener('DOMContentLoaded', function() {
  // Re-bind in case DOM is ready
  psBindEvents();
});
// Also run immediately in case DOMContentLoaded already fired
psBindEvents();

function psBindEvents() {
  // Lock/admin button
  var lb = document.getElementById('ps-lockBtn');
  if(lb) lb.addEventListener('click', psOpenPwModal);

  // Calc tab
  var ct = document.getElementById('ps-calcTab');
  if(!ct) ct = document.getElementById('ps-calcTab-btn');
  if(ct) ct.addEventListener('click', function(){ psShowTab('calc',this); });

  // File input - label handles click natively
  var fi = document.getElementById('ps-fi');
  if(fi) {
    fi.addEventListener('change', function(){ psOnFile(this); });
  }
  // Drag and drop
  var dz = document.getElementById('ps-dz');
  if(dz) {
    dz.addEventListener('dragover', function(e){ e.preventDefault(); dz.classList.add('drag'); });
    dz.addEventListener('dragleave', function(){ dz.classList.remove('drag'); });
    dz.addEventListener('drop', function(e){
      e.preventDefault(); dz.classList.remove('drag');
      var fi2 = document.getElementById('ps-fi');
      if(fi2 && e.dataTransfer.files.length){ fi2.files = e.dataTransfer.files; psOnFile(fi2); }
    });
  }

  // Kvalitet buttons via data attributes
  document.querySelectorAll('[data-kval]').forEach(function(btn){
    btn.addEventListener('click', function(){ psSelKval(this, parseFloat(this.dataset.kval), this.dataset.navn); });
  });

  // Kvalitet buttons via class (fallback)
  document.querySelectorAll('.ps-qual-btn').forEach(function(btn){
    if(!btn.dataset.kval) return;
    btn.addEventListener('click', function(){ psSelKval(this, parseFloat(this.dataset.kval), this.dataset.navn); });
  });

  // Produksjon buttons
  document.querySelectorAll('[data-prod]').forEach(function(btn){
    btn.addEventListener('click', function(){ psSelProd(this, parseFloat(this.dataset.prod), this.dataset.type); });
  });

  // Frakt buttons
  document.querySelectorAll('[data-frakt]').forEach(function(btn){
    btn.addEventListener('click', function(){ psSelFrakt(this, parseFloat(this.dataset.frakt), this.dataset.type); });
  });

  // Antall slider
  var qtyS = document.getElementById('ps-qtyS');
  if(qtyS) qtyS.addEventListener('input', psUpdatePrice);

  // Send button
  var sb = document.getElementById('ps-sendBtn');
  if(sb) sb.addEventListener('click', psSend);

  // Admin: lagre
  var saveBtn = document.querySelector('.ps-save-btn');
  if(saveBtn) saveBtn.addEventListener('click', psSaveConfig);

  // Admin: legg til material
  var addMatBtn = document.querySelector('.ps-add-mat-btn');
  if(addMatBtn) addMatBtn.addEventListener('click', psToggleNewForm);

  // Admin: avbryt ny material
  var cancelForm = document.querySelector('.ps-btn-ghost');
  if(cancelForm) cancelForm.addEventListener('click', psToggleNewForm);

  // Admin: bekreft ny material
  var addMat = document.querySelector('.ps-btn-primary');
  if(addMat) addMat.addEventListener('click', psAddMaterial);

  // Passord modal
  var login = document.querySelector('.ps-pw-login');
  if(login) login.addEventListener('click', psCheckPw);

  var cancel = document.querySelector('.ps-pw-cancel');
  if(cancel) cancel.addEventListener('click', psClosePwModal);

  var pwInput = document.getElementById('ps-pwInput');
  if(pwInput) pwInput.addEventListener('keydown', function(e){ if(e.key==='Enter') psCheckPw(); });
}